// extracted by mini-css-extract-plugin
export default {"logo":"LogoLight_logo__kGQp3"};